module.exports = __webpack_public_path__ + "static/media/shapiro_foam.a6defeb9.png";